import React from "react";
import './styles/WelcomeScreen.css';

function WelcomeScreen({ mini }) {
  return (
    <div className={mini ? "welcome-chatapp-msg" : "splash-bg"}>
      <div className={mini ? "" : "splash-content"}>
        <div className={mini ? "welcome-chatapp-logo" : "splash-logo"}>
          <img 
            src="icons/ucma_logo_transparent.png" 
            alt="UCMAAPP Logo" 
            style={{ 
              borderRadius: '20%',
              width: '100%',
              maxWidth: mini ? '380px' : '480px',
              height: 'auto'
            }}
          />
        </div>
        {mini ? (
          <div className="welcome-chatapp-desc">Select a user to start chatting</div>
        ) : null}
      </div>
    </div>
  );
}

export default WelcomeScreen; 